import {isPlatformBrowser} from '@angular/common';
import {inject, Injectable, PLATFORM_ID} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);

  /**
   * Sets an item in local storage.
   * @param key The key of the item.
   * @param value The value of the item.
   */
  setItem(key: string, value: string): void {
    if (this.isBrowser) {
      localStorage.setItem(key, value);
    }
  }

  /**
   * Gets an item from local storage.
   * @param key The key of the item.
   * @returns The value of the item, or null if not found.
   */
  getItem(key: string): string | null {
    if (this.isBrowser) {
      return localStorage.getItem(key);
    }
    return null;
  }

  /**
   * Removes an item from local storage.
   * @param key The key of the item to remove.
   */
  removeItem(key: string): void {
    if (this.isBrowser) {
      localStorage.removeItem(key);
    }
  }

  /**
   * Clears all items from local storage.
   */
  clear(): void {
    if (this.isBrowser) {
      localStorage.clear();
    }
  }
}
